module.exports = __webpack_public_path__ + "media/images/default/shared/favicon-6f8f98b8760d433561d999692f52e878.png";